import type { JSX } from "react";

import { Navigate, Route, Routes } from "react-router-dom";
import AiPersonalityRoutes from "./aiPersonalities/AiPersonalityRoutes";
import ApiCostRoutes from "./apiCosts/ApiCostRoutes";
import AppCaches from "./caches/AppCaches";
import DocumentRoutes from "./documents/DocumentRoutes";
import ExternalRoutes from "./externals/ExternalRoutes";
import ImageThreadsRoutes from "./imageThreads/ImageThreadsRoutes";
import MissingInformationRoutes from "./missingInformation/MissingInformationRoutes";
import ThreadRoutes from "./threads/ThreadRoutes";
import TranscriptionsRoutes from "./transcriptions/TranscriptionsRoutes";
import TtsRoutes from "./tts/TtsRoutes";
import UserRoutes from "./users/UserRoutes";

function AppRoutes(): JSX.Element {
    return (
        <Routes>
            <Route path="/threads/*" element={<ThreadRoutes />} />
            <Route path="/image-threads/*" element={<ImageThreadsRoutes />} />
            <Route path="/tts/*" element={<TtsRoutes />} />
            <Route path="/users/*" element={<UserRoutes />} />
            <Route path="/externals/*" element={<ExternalRoutes />} />
            <Route path="/ai-personalities/*" element={<AiPersonalityRoutes />} />
            <Route path="/documents/*" element={<DocumentRoutes />} />
            <Route path="/missing-information/*" element={<MissingInformationRoutes />} />
            <Route path="/transcriptions/*" element={<TranscriptionsRoutes />} />
            <Route path="/cache" element={<AppCaches />} />
            <Route path="/api-costs/*" element={<ApiCostRoutes />} />
            <Route path="/" element={<Navigate to="/threads" />} />
        </Routes>
    );
}

export default AppRoutes;
